import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "about" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  href: "https://github.com/epinio/epinio",
  target: "_blank",
  rel: "nofollow noopener noreferrer"
}
const _hoisted_4 = { class: "pt-40" }
const _hoisted_5 = { class: "os" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

import { onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { MANAGEMENT } from '@shell/config/types';
import { getVendor } from '@shell/config/private-label';

const downloadLinuxImages = null;


export default /*@__PURE__*/_defineComponent({
  __name: 'about',
  setup(__props) {

const store = useStore();

const version = ref<any>(null);
const settings = ref<any[]>([]);

const t = store.getters['i18n/t'];

const aboutVersionsComponentString = computed(() => t('about.versions.component'));
const aboutTitleString = computed(() => t('about.title'));
const aboutVersionsVersionString = computed(() => t('about.versions.version'));
const aboutDownloadCLIString = computed(() => t('about.downloadCLI.title'));
const allPackagesString = computed(() => t('epinio.about.allPackages'));


const fetchData = async () => {
  settings.value = await store.dispatch(`management/findAll`, { type: MANAGEMENT.SETTING });
  version.value = await store.dispatch('epinio/version');
};

onMounted(fetchData);

const appName = computed(() => {
  const isSingleProduct = !!store.getters['isSingleProduct'];
  return isSingleProduct ? getVendor() : t('epinio.label');
});

function createOSOption(label: string, icon: string, cliLink: string, imageList: any = null) {
  const slash = cliLink?.lastIndexOf('/');
  return {
    label,
    icon,
    imageList,
    cliLink,
    cliFile: slash >= 0 ? cliLink.substr(slash + 1) : cliLink
  };
}

const downloads = computed(() => {
  if (!version.value) {
    return [];
  }

  const gitUrl = `https://github.com/epinio/epinio/releases/download`;
  const versionStr = version.value.displayVersion;
  const app = appName.value.toLowerCase();

  return [
    createOSOption('about.os.mac', 'icon-apple', `${gitUrl}/${versionStr}/${app}-darwin-x86_64`),
    createOSOption('about.os.linux', 'icon-linux', `${gitUrl}/${versionStr}/${app}-linux-x86_64`, downloadLinuxImages),
    createOSOption('about.os.windows', 'icon-windows', `${gitUrl}/${versionStr}/${app}-windows-x86_64.zip`)
  ];
});

const versionString = computed(() => {
  if (!version.value) return '';
  if (version.value.displayVersion === version.value.fullVersion) {
    return version.value.displayVersion;
  }
  return version.value.fullVersion;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (version.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h1", null, _toDisplayString(aboutTitleString.value), 1),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(aboutVersionsComponentString.value), 1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("th", null, _toDisplayString(aboutVersionsVersionString.value), 1)
              ])
            ]),
            _cache[2] || (_cache[2] = _createTextVNode()),
            (version.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                  _createElementVNode("td", null, [
                    _createElementVNode("a", _hoisted_3, _toDisplayString(appName.value), 1)
                  ]),
                  _cache[1] || (_cache[1] = _createTextVNode()),
                  _createElementVNode("td", null, _toDisplayString(versionString.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createTextVNode()),
    (version.value && downloads.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(aboutDownloadCLIString.value), 1),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("table", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downloads.value, (d) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: d.icon,
                class: "link"
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`icon ${d.icon} mr-5`)
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(_unref(t)(d.label)), 1)
                  ])
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("td", null, [
                  (d.cliLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: d.cliLink
                      }, _toDisplayString(d.cliFile), 9, _hoisted_6))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true),
    _cache[7] || (_cache[7] = _createTextVNode()),
    (version.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          class: "mt-5",
          target: "_blank",
          href: `https://github.com/epinio/epinio/releases/tag/${version.value.displayVersion}`
        }, _toDisplayString(allPackagesString.value), 9, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

})